import type { AttendanceStatus } from "./types";

export const STATUS_COLORS: Record<AttendanceStatus, string> = {
  present : "var(--success)",   // green-500
  wfh     : "var(--info)",      // sky-700
  absent  : "var(--danger)",    // red-500
  weekend : "var(--neutral)",   // slate-500
  leave   : "var(--warning)",   // amber-600
};

export const STATUS_OPACITY: Record<AttendanceStatus, number> = {
  present : 0.85,
  wfh     : 0.85,
  absent  : 0.85,
  weekend : 0.85,
  leave   : 0.85,
};

export const STATUS_LABELS: Record<AttendanceStatus, string> = {
  present : "In Office",
  wfh     : "Work From Home",
  absent  : "Absent",
  weekend : "Weekend",
  leave   : "On Leave",
};

export const LEGEND_ITEMS: AttendanceStatus[] = [
  "present",
  "wfh",
  "leave",
  "absent",
  "weekend",
];

// Leave types that map to WFH vs general leave
export const WFH_LEAVE_TYPE     = "WorkFromHome";
export const LEAVE_TYPES        = ["CasualLeave", "PrivilegeLeave", "HalfDayLeave", "ShortLeave"] as const;
export const WEEKEND_DAYS       = ["Sat", "Sun"] as const;

/** Display text for chart / tooltip (matches API `leaveType` values). */
export const LEAVE_TYPE_LABELS: Record<(typeof LEAVE_TYPES)[number], string> = {
  CasualLeave: "Casual leave",
  PrivilegeLeave: "Privilege leave",
  HalfDayLeave: "Half day leave",
  ShortLeave: "Short leave",
};

export function labelForLeaveType(leaveType: string | undefined | null): string {
  if (leaveType == null || String(leaveType).trim() === "") {
    return STATUS_LABELS.leave;
  }
  const key = leaveType as (typeof LEAVE_TYPES)[number];
  return LEAVE_TYPE_LABELS[key] ?? STATUS_LABELS.leave;
}

// Bar chart Y-axis ceiling (hours)
export const CHART_Y_MAX = 10;

/** Minimum bar height (hours) for weekend when API has no hours, so the bar is visible */
export const CHART_WEEKEND_MIN_BAR_HOURS = 1.5;
